import actions from "./actions";

const {FETCH_EMAILS, RESET_EMAIL, RECEIVED_EMAILS} = actions;
const initState = {
    emails: {
        page: 0,
         perPage: 35,
        data: [],
        total: 0
    },
    receivedEmails: {data: []},
    email: {_id: null}
};

const EmailReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_EMAILS:
            return {
                ...state,
                emails: data
            }
        case RECEIVED_EMAILS:
            return {
                ...state,
                receivedEmails: data
            }
        case RESET_EMAIL:
            return {
                ...state,
                email: initState.email,
            };
        default:
            return state;
    }
}

export default EmailReducer;
